import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import axios from 'axios' // remove comment if yu needed
import parserFilters from '@/utils/parserFilters'

Vue.use(Vuex)

const state = {
  conceptsPagination: {
    currentPage: 1,
    totalPages: 0
  },
  projectsPagination: {
    currentPage: 1,
    totalPages: 0
  },
  administrativeConceptsPagination: {
    currentPage: 1,
    totalPages: 0
  },
  concepts: [],
  projects: [],
  administrativeConcepts: [],
  isModalProjectsVisible: false,
  isModalConceptsVisible: false,
  isModalChangeStatusVisible: false,
  monthlyStatistic: {
    expenses: 0,
    income: 0,
    difference: 0,
    balance: 0
  },
  filterParams: '',
  balance: {
    balance: 0,
    payable: 0,
    receivable: 0,
    in_account: 0
  }
}

const mutations = {
  SET_CONCEPTS (state, payload) {
    state.concepts = payload.data
  },
  SET_PROJECTS (state, payload) {
    state.projects = payload.data
  },
  SET_ADMINISTRATIVE_CONCEPTS (state, payload) {
    state.administrativeConcepts = payload.data
  },
  SET_CONCEPTS_PAGINATION (state, payload) {
    state.conceptsPagination = {
      currentPage: payload.current_page,
      totalPages: payload.last_page
    }
  },
  SET_PROJECTS_PAGINATION (state, payload) {
    state.projectsPagination = {
      currentPage: payload.current_page,
      totalPages: payload.last_page
    }
  },
  SET_ADMINISTRATIVE_CONCEPTS_PAGINATION (state, payload) {
    state.administrativeConceptsPagination = {
      currentPage: payload.current_page,
      totalPages: payload.last_page
    }
  },

  SET_MONTHLY_STATISTIC (state, payload) {
    state.monthlyStatistic = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_BALANCE (state, payload) {
    state.balance = payload
  },
  ADD_CONCEPT (state, payload) {
    state.concepts.unshift(payload)
  },
  UPDATE_BALANCE (state, payload) {
    state.monthlyStatistic = {
      expenses: state.monthlyStatistic.expenses + payload.charge,
      income: state.monthlyStatistic.income + payload.payment,
      difference: state.monthlyStatistic.difference + (payload.payment - payload.charge),
      balance: state.monthlyStatistic.balance + (payload.payment - payload.charge)
    }
  },
  CHANGE_STATUS (state, payload) {
    state.projects.unshift(payload)
  },
  UPDATE_CONCEPTS (state, payload) {
    const idx = state.concepts.findIndex(u => u.id === payload.id)
    state.concepts[idx] = payload
    if (idx >= 0) {
      Vue.set(state.concepts, idx, payload)
    }
  },
  UPDATE_PROJECTS (state, payload) {
    const idx = state.projects.findIndex(u => u.id === payload.id)
    state.projects[idx] = payload
    if (idx >= 0) {
      Vue.set(state.projects, idx, payload)
    }
  },
  DELETE_CONCEPT (state, payload) {
    const idx = state.concepts.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.concepts, idx)
    }
  },
  DELETE_PROJECT (state, payload) {
    const idx = state.projects.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.projects, idx)
    }
  },
  DELETE_ADMINISTRATIVE (state, payload) {
    const idx = state.administrativeConcepts.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.administrativeConcepts, idx)
    }
  }
}

const actions = {
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  updateBalance ({ commit }, payload) {
    payload.status === 1 && commit('UPDATE_BALANCE', payload)
  },
  async setDateAlert ({ commit }) {
    commit('SET_ALERT_MESSAGE', { color: 'warning', title: 'errors.warning', text: 'errors.invalid_date' }, { root: true })
  },
  async loadMonthlyStatistic ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(
        `monthly-statistics?year=${payload.year}&month=${payload.month}`
      )
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_MONTHLY_STATISTIC', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async loadConcepts ({ commit, state }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.get(`concepts?page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_CONCEPTS', response.data)
        commit('SET_CONCEPTS_PAGINATION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async loadProjects ({ commit }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.get(`projects?page=${payload.page}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_PROJECTS', response.data)
        commit('SET_PROJECTS_PAGINATION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async loadAdministrativeConcepts ({ commit }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.get(
        `administrative-concepts?page=${payload.page}`
      )
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_ADMINISTRATIVE_CONCEPTS', response.data)
        commit('SET_ADMINISTRATIVE_CONCEPTS_PAGINATION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async loadBalance ({ commit }) {
    app.$Progress.start()

    try {
      const response = await axios.get(`balance`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_BALANCE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async editConcept ({ commit }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.put(`concepts/${payload.id}`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('UPDATE_CONCEPTS', response.data)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.concepts',
            text: 'front.updated_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async editProject ({ commit }, payload) {
    payload.status === 2
      ? (payload.finish_date = moment().format('YYYY-MM-DD'))
      : (payload.finish_date = null)
    app.$Progress.start()

    try {
      const response = await axios.put(`projects/${payload.id}`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('UPDATE_PROJECTS', response.data)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.projects',
            text: 'front.updated_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteRecord ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`${payload.route}/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit(`DELETE_${payload.type}`, payload)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: `strings.${payload.route}`,
            text: 'front.deleted_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  exportConcepts ({ commit }) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/concepts/export?format=csv${state.filterParams}`)
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  concepts: state => state.concepts,
  conceptsPagination: state => state.conceptsPagination,
  projects: state => state.projects,
  projectsPagination: state => state.projectsPagination,
  administrativeConcepts: state => state.administrativeConcepts,
  administrativeConceptsPagination: state => state.administrativeConceptsPagination,
  isModalProjectsVisible: state => state.isModalProjectsVisible,
  isModalConceptsVisible: state => state.isModalConceptsVisible,
  monthlyStatistic: state => state.monthlyStatistic,
  filterParams: state => state.filterParams,
  balance: state => state.balance,
  isModalChangeStatusVisible: state => state.isModalChangeStatusVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
